import { FC, HTMLAttributes, useMemo } from 'react'
import css from 'styled-jsx/css'
// import getConfig from 'next/config'
import { isValidTimeToEnableShopHelp } from '@ui/helpers'
// import { logger } from '@ui/analytics'
import ShopHelpLogo from '../ShopHelp/ShopHelpLogo'
import { useIsShowShophelp } from '@ui/hooks'

interface IServeByShopHelp extends HTMLAttributes<HTMLDivElement> {
  type?: 'desktop' | 'mobile'
}

// const shophelpUrl = getConfig().publicRuntimeConfig.shophelpUrl ?? ''
// const deepLink = getConfig().publicRuntimeConfig.shophelpDeepLink ?? ''

const ServeByShopHelp: FC<IServeByShopHelp> = ({ className }) => {
  const isShowShophelp = useIsShowShophelp()
  // const [desktopLink, setDesktopLink] = useState(`${shophelpUrl}/pre-shophelp`)
  // const [isIos, setIsIos] = useState(false)

  const promotionShopHelp = useMemo(() => isShowShophelp && isValidTimeToEnableShopHelp(), [
    isShowShophelp
  ])

  // const logOpenShopHelp = () => {
  //   logger.logShopHelp('OPEN')
  // }

  // useEffect(() => {
  //   if (window) {
  //     setDesktopLink(`${shophelpUrl}/pre-shophelp?fromShop=${window.location.hostname}`)
  //   }
  //   setIsIos(isAndroidIos())
  // }, [])

  return (
    <>
      <style jsx>{style}</style>
      {promotionShopHelp && (
        <div className="non-bg">
          <span
            className={`servedby-shophelp ${className ?? ''}`}
            // href={!isIos ? desktopLink : deepLink}
            // onClick={logOpenShopHelp}
          >
            <span className="is-flex">
              Served by <ShopHelpLogo className="ml-2" height={92} width={150} />
            </span>
          </span>
        </div>
      )}
    </>
  )
}

const style = css`
  .non-bg {
    background-color: #ffffff;
  }

  .servedby-shophelp {
    span {
      font-size: 15px;
      line-height: 32px;
      align-items: center;
      justify-content: center;
      color: var(--text);
    }
  }
`

export default ServeByShopHelp
